/* Kauf-Verdrahtung — verbindet die Auswahl auf der Seite mit den echten Shopify-Varianten.
 *
 * Grundsatz: Es wird NUR gekauft, wenn zur Auswahl eine echte Variante existiert UND
 * ihr Preis dem entspricht, der auf der Seite steht. Fehlt sie oder weicht der Preis ab,
 * bleibt der Knopf gesperrt und sagt das auch — ein anderer Preis im Warenkorb als auf
 * der Seite waere eine Preisfalle.
 *
 * Der Seitenzustand wird aus dem DOM gelesen: die Vorlagen halten `setKey` und `state`
 * in einer eigenen Funktion, von aussen sichtbar sind nur #setName, .swatch.active
 * und .bundle.active.
 */
(function () {
  'use strict';

  var D = window.TA_SHOP;

  /* --- Seitenauswahl -> Shopify-Optionswerte ------------------------------ */

  /* Die Farbschalter tragen data-key; data-color ist der Marketingname
     ("Obsidian Schwarz"), der so nicht in Shopify steht. */
  var FARBE = {
    schwarz: 'Schwarz', blau: 'Blau', rosa: 'Rosa', weiss: 'Weiß', weiß: 'Weiß'
  };

  /* Sets, die ueber data-set laufen (Munddusche) statt ueber #setName. */
  var SET_WERT = {
    '2er': '2er Düsen-Set',
    '6er': '6-er Düsen Set',
    'duo': 'Familien Set (Sparpack)'
  };

  function aktiveFarbe() {
    var s = document.querySelector('.swatch.active, .col.active, [data-color].active');
    if (!s) return null;
    return FARBE[s.dataset.key] || s.dataset.color || null;
  }

  /* Ausstattung steht im Klartext in #setName — die Optionswerte in Shopify
     sind bewusst genauso benannt. Nur der Produktname davor muss weg:
     "Business Class · Einzeln" -> "Einzeln". */
  function aktiveAusstattung() {
    var e = document.getElementById('setName');
    if (!e) return null;
    var t = (e.textContent || '').trim();
    if (!t) return null;
    var i = t.lastIndexOf('·');
    return (i >= 0) ? t.slice(i + 1).trim() : t;
  }

  function aktivesSet() {
    var b = document.querySelector('.bundle.active[data-set], [data-set].active');
    var k = b ? b.dataset.set : new URLSearchParams(location.search).get('set');
    /* NUR bekannte Set-Schluessel in echte Shopify-Optionswerte uebersetzen.
       Die uebrigen Schluessel (solo/etui/uv/uv6/...) sind KEINE Optionswerte —
       sie als Filter zu verwenden leerte die Trefferliste, und der Preis-Notbehelf
       nahm dann die erstbeste preisgleiche Variante in der FALSCHEN FARBE
       (Bug gefunden 2.9.2026 beim Warenkorb-Volltest). Bei diesen Produkten steckt
       die Ausstattung ohnehin in #setName (aktiveAusstattung). */
    return k ? (SET_WERT[k] || null) : null;
  }

  function aktiveMenge() {
    var b = document.querySelector('.bundle.active[data-qty]');
    var q = b ? b.dataset.qty : new URLSearchParams(location.search).get('qty');
    if (!q) return null;
    return (q === 'two' || q === '2') ? 'Doppelpack - Vorteilspack' : 'Einzelgerät';
  }

  /* --- Variante bestimmen ------------------------------------------------- */

  function angezeigterPreis() {
    var e = document.getElementById('priceNow') || document.querySelector('.now, .price-now');
    if (!e) return null;
    var m = (e.textContent || '').match(/(\d{1,4})[.,](\d{2})/);
    if (!m) return null;
    return parseInt(m[1], 10) * 100 + parseInt(m[2], 10);   // in Cent
  }

  function hatWert(v, wert) {
    if (!wert) return true;                       // nicht ausgewaehlt -> kein Filter
    var w = v.werte || [];
    for (var i = 0; i < w.length; i++) if (w[i] === wert) return true;
    return false;
  }

  function variante() {
    if (!D.varianten.length) return null;
    if (D.varianten.length === 1) return D.varianten[0];

    var gesucht = [aktiveFarbe(), aktiveAusstattung(), aktivesSet(), aktiveMenge()];

    var treffer = D.varianten.filter(function (v) {
      for (var i = 0; i < gesucht.length; i++) if (!hatWert(v, gesucht[i])) return false;
      return true;
    });

    if (treffer.length === 1) return treffer[0];

    /* Mehrdeutig oder nichts gefunden: der angezeigte Preis entscheidet.
       Ohne Preis lieber gar nichts — nie eine beliebige Variante nehmen. */
    var soll = angezeigterPreis();
    if (soll === null) return treffer.length ? treffer[0] : null;

    var menge = treffer.length ? treffer : D.varianten;
    for (var i = 0; i < menge.length; i++) {
      if (Math.abs(Number(menge[i].preis) - soll) <= 1) return menge[i];
    }
    return null;
  }

  /* --- Warenkorb ---------------------------------------------------------- */

  function zaehlerSetzen(anzahl) {
    document.querySelectorAll('.cart-full').forEach(function (e) {
      e.textContent = 'Warenkorb · ' + anzahl;
    });
    document.querySelectorAll('.cart-mini b').forEach(function (e) {
      e.textContent = anzahl;
    });
    var mini = document.querySelector('.cart-mini');
    if (mini) mini.setAttribute('aria-label', 'Warenkorb, ' + anzahl + ' Artikel');
  }

  function zaehlerLaden() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { zaehlerSetzen(c.item_count); })
      .catch(function () { });
  }

  function rueckmeldung(knopf, text, dauer) {
    var alt = knopf.dataset.taText || knopf.textContent;
    knopf.dataset.taText = alt;
    knopf.textContent = text;
    knopf.disabled = true;
    setTimeout(function () { knopf.textContent = alt; knopf.disabled = false; }, dauer || 1600);
  }

  function inDenWarenkorb(knopf) {
    var v = variante();
    if (!v) {
      rueckmeldung(knopf, 'Diese Auswahl ist noch nicht bestellbar', 2600);
      return;
    }
    if (v.verfuegbar === false) {
      rueckmeldung(knopf, 'Derzeit ausverkauft', 2600);
      return;
    }
    /* Preis-Sicherung: im Warenkorb muss stehen, was auf der Seite steht. */
    var soll = angezeigterPreis();
    if (soll !== null && Math.abs(soll - Number(v.preis)) > 1) {
      rueckmeldung(knopf, 'Diese Zusammenstellung ist noch nicht bestellbar', 3000);
      if (window.console) {
        console.warn('[Kauf gestoppt] Seitenpreis ' + (soll / 100).toFixed(2) +
          ' € weicht von Variante "' + v.titel + '" (' + (Number(v.preis) / 100).toFixed(2) +
          ' €) ab. Es wurde nichts in den Warenkorb gelegt.');
      }
      return;
    }

    var alt = knopf.textContent;
    knopf.disabled = true;
    knopf.textContent = 'Wird hinzugefügt …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        // Direkt zum Warenkorb — der kuerzeste Weg Richtung Kasse
        // (Conversion-Entscheidung 8.9.2026, wie bei den grossen Shops).
        knopf.textContent = 'Im Warenkorb ✓';
        window.location.href = '/cart';
      })
      .catch(function () {
        knopf.textContent = alt;
        knopf.disabled = false;
        rueckmeldung(knopf, 'Bitte erneut versuchen');
      });
  }

  /* --- Knoepfe verdrahten -------------------------------------------------- */

  var IDS = ['addToCart', 'ctaBuy', 'stickyAdd', 'klBtn'];

  function verdrahten(el) {
    if (!el || el.dataset.taKauf) return;
    el.dataset.taKauf = '1';
    el.addEventListener('click', function (ev) {
      ev.preventDefault();
      inDenWarenkorb(el);
    });
  }

  function alleVerdrahten() {
    IDS.forEach(function (id) { verdrahten(document.getElementById(id)); });
  }

  /* Der Zaehler laeuft auf JEDER Seite (die Navigation ist ueberall gleich),
     die Kauflogik nur dort, wo ein Produkt mit Varianten hinterlegt ist. */
  zaehlerLaden();

  if (!D || !D.varianten || !D.varianten.length) return;

  alleVerdrahten();
  /* Kauf-Balken und Lightbox entstehen teils erst spaeter im Seitenablauf. */
  new MutationObserver(alleVerdrahten).observe(document.body, { childList: true, subtree: true });
})();
